/* eslint-disable */
export default {
  _mobile_grass_mobile: 'mobile/grass-mobile',
  _mobile_grass_mobile_withblanket: 'mobile/grass-mobile_withblanket',
  _game_items_bckg_horizon: 'game-items/bckg_horizon',
  _game_items_pause_bg: 'game-items/pause-bg',
  _game_items_btn_playagain: 'game-items/btn_playagain',
  _game_items_score_bg_0: 'game-items/score-bg_0',
  _game_items_btn_home: 'game-items/btn_home',
  _game_items_btn_resume: 'game-items/btn_resume',
  _animations_basket_open_0: 'animations/basket-open_0',
  _animations_bird_fly_3: 'animations/bird-fly_3',
  _game_items_cup_red_title_0: 'game-items/cup-red-title_0',
  _game_items_cloud_5_0: 'game-items/cloud-5_0',
  _animations_eye_idle_0: 'animations/eye-idle_0',
  _animations_eye_blink_1: 'animations/eye-blink_1',
  _animations_bird_fly_0: 'animations/bird-fly_0',
  _game_items_cloud_2_0: 'game-items/cloud-2_0',
  _animations_bird_idle_0: 'animations/bird-idle_0',
  _mobile_btn_keyboard: 'mobile/btn_keyboard',
  _game_items_cloud_1_0: 'game-items/cloud-1_0',
  _game_items_cup_yellow_title_0: 'game-items/cup-yellow-title_0',
  _game_items_cup_blue_title_0: 'game-items/cup-blue-title_0',
  _grass_portrait: 'grass-portrait',
  _game_items_cup_outline_0: 'game-items/cup-outline_0',
  _game_items_cloud_4_0: 'game-items/cloud-4_0',
  _game_items_cup_blue_0: 'game-items/cup-blue_0',
  _grass_portrait_withblanket: 'grass-portrait_withblanket',
  _game_items_cup_red_0: 'game-items/cup-red_0',
  _game_items_cup_yellow_0: 'game-items/cup-yellow_0',
  _game_items_btnInfo_0: 'game-items/btnInfo_0',
  _game_items_cloud_3_0: 'game-items/cloud-3_0',
  _game_items_speaker_off_0: 'game-items/speaker-off_0',
  _game_items_speaker_on_0: 'game-items/speaker-on_0',
}